export const UNIT_OF_MEASURE_LABEL_ID = 'metricUnitOfMeasureLabel';

/**
 * Ids of the definition rows' visible labels. The label sits in the row's gutter and the control
 * beside it, so each control names itself after its label with `aria-labelledby`.
 */
export const ANALYSIS_TYPE_LABEL_ID = 'metricAnalysisTypeLabel';
export const ANALYSIS_UNIT_LABEL_ID = 'metricAnalysisUnitLabel';
export const PERCENTILE_LEVEL_LABEL_ID = 'metricPercentileLevelLabel';
export const SUCCESS_CRITERIA_LABEL_ID = 'metricSuccessCriteriaLabel';
export const UNITS_WITHOUT_EVENTS_LABEL_ID = 'metricUnitsWithoutEventsLabel';
